import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import { connectorById } from 'scaleflow/utils/connectors-config';

class ConnectorsGithubRoute extends Route {
  model() {
    return {
      connector: connectorById('github'),
      integrations: this.modelFor('connectors'),
    };
  }
}

export default instrumentRoutePerformance(ConnectorsGithubRoute);
